import type { InjectionKey } from 'vue'


export const KeyboardHandlerKey = Symbol('provideKeyboardHandler')

export const ContainerBreakpointsKey = Symbol('provideContainerBreakpoints')

export const NotificationHandlerKey
  = Symbol('provideContainerBreakpoints') as InjectionKey<{ onError: (e: unknown) => void }>
